import React, { useEffect, useState } from "react";
import "../component/style.css";
import { UserApi } from "../apis";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Alert
} from "@mui/material";
import CustomInput from "../component/customInput";
import { useNavigate } from "react-router-dom";

const ForgetPassword = () => {
  const [displayUpdateModal, setDisplayUpdateModal] = useState(true);
  const UserRouter = UserApi();
  const navigate = useNavigate();

  // Attributes
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [message, setMessage] = useState("");

  const [newPasswordErr, setNewPasswordErr] = useState("");
  const toggleUpdateModal = () => setDisplayUpdateModal(!displayUpdateModal);

  useEffect(() => {
    const currentUrl = window.location.href;
    const urlObj = new URL(currentUrl);

    const token = urlObj.searchParams.get("token");
    setToken(token);
  }, []);

  const UpdatePassword = async () => {
    try {
      let isValid = true;
      if (!newPassword) {
        setNewPasswordErr("Password is required");
        isValid = false;
      }

      if (!isValid) return null;

      const res = await UserRouter.forgetPassword({
        token: token,
        newPassword: newPassword,
      });

      if (res.status !== 200 && res.status !== 201) {
        const msg =
          res?.error?.response?.data?.message || "An unknown error occurred";
        setMessage(msg);
        setAlertType("error");
        setShowAlert(true);
      } else {
        navigate("/SignIn");
      }
    } catch (error) {
      console.log("Login Error", error);
    }
  };

  return (
    <>
      <div className="mainContainer">
        {/* Add Dialog */}
        <Dialog open={displayUpdateModal} onClose={toggleUpdateModal}>
          <DialogTitle>Update Password</DialogTitle>
          <DialogContent>
            <CustomInput
              id="newPassword"
              name="newPassword"
              title="Enter New Password"
              titleRequired={true}
              isRequired={true}
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                setNewPasswordErr("");
              }}
              type="text"
              placeholder="enter new password"
              required={newPasswordErr.length > 0 ? true : false}
              helperText={newPasswordErr}
              width="100%"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleUpdateModal}>Cancel</Button>
            <Button onClick={() => UpdatePassword()}>Update</Button>
          </DialogActions>
        </Dialog>
      </div>

      {showAlert && (
        <Alert
          severity={alertType}
          sx={{
            position: "absolute",
            top: "100px",
            right: "20px",
            width: "300px",
          }}
        >
          {message}
        </Alert>
      )}
    </>
  );
};

export default ForgetPassword;
